export const es = {
  title: 'Bosques primarios',
  subtitle: '30 m, trópicos, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Función',
      value:
        'Este conjunto de datos representa la extensión de los bosques primarios en las regiones pantropicales del mundo en 2001.',
    },
    {
      label: 'Resolución',
      value: '30 × 30 metros',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Pan-tropical',
    },
    {
      label: 'Fuente',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Fecha del contenido',
      value: 2001,
    },
  ],
  overview: {
    label: 'Descripción',
    value:
      'Los bosques primarios se encuentran entre los bosques más biodiversos, proporcionando una multitud de servicios ecosistémicos, lo que hace crucial el monitoreo de su planeación de uso de suelo y contabilidad de carbono a nivel nacional. Este conjunto de datos define bosques primarios como "superficies forestales tropicales húmedas naturales maduras que no han sido despejadas y reforestadas completamente en la historia reciente".',
  },
  citation: {
    label: 'Citación',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
